module.exports = __webpack_public_path__ + "img/banner.79910a01.png";